'use client';

import { ButtonClose } from '@/components/buttons';
import { useGetCommonStore, useModalsStore } from '@/store';

export const ButtonModalClose = () => {
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const close = useModalsStore.use.close();

  return (
    <ButtonClose
      gray
      onClick={() => close()}
      right={isMobileDevice ? 8 : 12}
      top={isMobileDevice ? 8 : 12}
    />
  );
};
